import User from "@/shared/models/User";
import ChangeTrackedEvent from "@/shared/models/ChangeTrackedEvent";
import DocumentMetadata from "@/features/Documents/DocumentMetadata";

export enum IncidentSeverity {
    minor,
    moderate,
    major,
    critical,
}

export enum UIIncidentSeverity {
    "Minor",
    "Moderate",
    "Major",
    "Critical",
}

export default class Incident {
    id: string = "";
    supplierID: string = "";
    createdTimestampUTC: Date = new Date();
    createdBy: User = new User();
    createdByID: string = "";
    updatedTimestampUTC: Date = new Date();
    updatedBy: User | null = null;
    updatedByID: string = "";
    incidentDate: Date = new Date();
    severity: IncidentSeverity = IncidentSeverity.minor;
    questNumber: string = "";
    description: string = "";
    documentMetadatas: DocumentMetadata[] = [];
    documentMetadataIDs: string[] = [];
    events: ChangeTrackedEvent[] = [];
}
